import { twMerge } from 'src/utils/tw-merge.util'

interface DocumentStatusPillProps {
  label: string
  isAvailable: boolean
}

const DocumentStatusPill = ({ label, isAvailable }: DocumentStatusPillProps) => (
  <span
    className={twMerge(
      'c-shrink-0 c-rounded c-px-2 c-py-1 c-text-[10px] c-font-semibold c-leading-[14px]',
      isAvailable
        ? 'c-bg-document-status-available-bg c-text-document-status-available-text'
        : 'c-bg-document-status-pending-bg c-text-document-status-pending-text',
    )}
  >
    {label}
  </span>
)

export { DocumentStatusPill }
